import PropTypes from 'prop-types'
import InputWiz from '../../../../../../../common/inputs/wizard/InputWiz.jsx'
import FormRepeater from '../../../../../../../common/FormReapeater.jsx'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import {Trash} from "react-bootstrap-icons";
import {Card, Col, Row} from "react-bootstrap";
import TextareaWiz from "../../../../../../../common/inputs/wizard/TextareaWiz.jsx";
import DateTimeWiz from "../../../../../../../common/inputs/wizard/DateTimeWiz.jsx";
import InputNumericWiz from "../../../../../../../common/inputs/wizard/InputNumericWiz.jsx";
import {KamienieMiloweRepeater} from "../../../KamienieMiloweRepeater.jsx";

export const ZadaniaList = (props) => {
    // const allow = {
    //     hide: {},
    // }

    return (
        <>
            <JsonViewer src={props.wiz?.form || {}} show={true}/>

            <HeaderTitle noHr size={'fs-3'} title={'Zadania'}/>

            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź informacje o zadaniach'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <FormRepeater
                    value={props.wiz.form?.zadania_list || []}
                    onChange={(list) => props.wiz.setValue('zadania_list', list)}
                    addButtonText="Dodaj zadanie"
                    hideNativeDelete
                    form={(row, setRow, idx, remove) => (
                        <Card className={'d-flex flex-column gap-5 mb-3 w-full'}>
                            <Card.Body className={'p-3 mb-2 w-full'}>
                                <div className={'d-flex gap-5'}>

                                    <ButtonWithIcon
                                        text={`Usuń zadanie ${idx + 1}`}
                                        onClick={() => remove(idx)}
                                        icon={<Trash/>}
                                        variant={'danger'}
                                        className={'mt-4 align-self-start ms-auto'}
                                    />

                                    <Row>
                                        <Col>


                                            <TextareaWiz
                                                wiz={props.wiz}
                                                keyName={`zadania_list.${idx}.nazwa`}
                                                row={row}
                                                setRow={setRow}
                                                idx={idx}
                                            />
                                        </Col>


                                        <DateTimeWiz
                                            wiz={props.wiz}
                                            keyName={`zadania_list.${idx}.data_rozpoczecia`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                        />
                                        <DateTimeWiz
                                            wiz={props.wiz}
                                            keyName={`zadania_list.${idx}.data_zakonczenia`}
                                            row={row}
                                            setRow={setRow}
                                            idx={idx}
                                        />
                                        <Col>


                                            <InputNumericWiz
                                                wiz={props.wiz}
                                                keyName={`zadania_list.${idx}.budzet`}
                                                row={row}
                                                setRow={setRow}
                                                idx={idx}
                                                decimal={2}
                                            />

                                            <KamienieMiloweRepeater
                                                {...props}
                                                parentListName={'zadania_list'}
                                                parentIdx={idx}
                                                row={row}
                                                setRow={setRow}
                                            />

                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    )}
                />
            </div>
        </>
    )
}

ZadaniaList.propTypes = {
    wiz: PropTypes.any,
}